import { createFileRoute, Link } from '@tanstack/react-router';

import { TipForm } from '@/components/site/tip-form';
import { Cell, GridShell } from '@/components/site/shell';
import { seoHead } from '@/lib/seo';

export const Route = createFileRoute('/tip')({
    head: () =>
        seoHead({
            title: 'שלחו ידיעה',
            description:
                'יש לכם ידיעה, תמונה או עדכון מאשקלון? שלחו לנו ונבדוק.',
            path: '/tip',
        }),
    component: TipPage,
});

function TipPage() {
    return (
        <GridShell activePath="/tip">
            <Cell className="px-6 py-12 sm:py-16">
                <p className="text-sm text-white/55">שלחו ידיעה</p>
                <h1 className="mt-2 max-w-2xl text-3xl font-normal tracking-tight text-white sm:text-4xl">
                    ראיתם משהו ששווה לדווח?
                </h1>
                <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/55">
                    כתבו לנו מה קרה, ואם יש תמונה או מספר לחזרה, צרפו אותם.
                    לא כל ידיעה מתפרסמת. נבדוק לפני שאנחנו מוציאים כתבה.
                    הטופס פתוח לשליחה מישראל בלבד.
                </p>

                <div className="mt-8 max-w-xl border border-white/10 bg-white/[0.02] p-6">
                    <TipForm />
                </div>

                <p className="mt-8 text-sm text-white/55">
                    <Link to="/" className="hover:text-white">
                        חזרה לדף הבית
                    </Link>
                </p>
            </Cell>
        </GridShell>
    );
}
